import React, { Component, Fragment } from "react";
import { withStyles } from "@material-ui/core/styles";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
  IconButton,
  DialogActions
} from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import CommentIcon from "@material-ui/icons/Comment";
import ReplyIcon from "@material-ui/icons/Reply";
import { WELCOME_PAGE } from "../../utils/Colors";

const TYPE_CONTAINER = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  padding: "10px",
  border: `1px solid ${WELCOME_PAGE.primaryColor}`,
  textAlign: "center",
  "&:hover": {
    cursor: "pointer"
  }
};

const styles = theme => ({
  root: {
    maxWidth: "450px",
    width: "100%",
    height: "100%",
    maxHeight: "400px",
    borderRadius: "10px",
    position: "relative"
  },
  dialogContentRoot: {
    [theme.breakpoints.down("md")]: {
      padding: "0 12px 24px"
    }
  },
  SkipBtn: {
    color: "white",
    backgroundColor: "#F37020",
    borderRadius: "50px",
    padding: "10px 30px",
    fontSize: "14px",
    textTransform: "none",
    minHeight: "0px",
    "&:hover": {
      color: "white",
      backgroundColor: "#F37020",
      opacity: "0.9"
    }
  },
  Title: {
    fontSize: "16px !important"
  },
  primaryText: {
    fontSize: "15px"
  },
  secondaryText: {
    fontSize: "13px"
  },
  activeContainer: {
    ...TYPE_CONTAINER,
    backgroundColor: WELCOME_PAGE.primaryColor
  },
  inactiveContainer: {
    ...TYPE_CONTAINER
  }
});

const TYPES = ["Notifications", "Interactions"];

class FeedbackList extends Component {
  constructor(props) {
    super(props);
    const { data = [], notifications = {} } = props;
    let activeTab = "Notifications";
    if (data.length !== 0 && Object.keys(notifications).length === 0) {
      activeTab = "Interactions";
    }
    this.state = {
      activeTab
    };
  }

  openOrderFeedback = (data, index) => () => {
    this.props.handleClose({ data, state: false, index });
  };

  switchTabs = tabname => event => {
    this.setState({ activeTab: tabname });
  };

  render() {
    const {
      classes,
      data = [],
      open,
      skip,
      handleClose,
      title,
      showIcon,
      showReplyIcon,
      notifications = {}
    } = this.props;
    const { root, SkipBtn, Title } = classes;

    let content = data.map((item, index) => (
      <React.Fragment>
        <ListItem
          button
          role={undefined}
          divider
          onClick={this.openOrderFeedback(item, index)}
        >
          <ListItemText
            primary={(item.displayText || {})["title"]}
            secondary={(item.displayText || {})["subTitle"]}
            classes={{
              primary: classes.primaryText,
              secondary: classes.secondaryText
            }}
          />
          {showIcon && (
            <ListItemSecondaryAction>
              <IconButton
                aria-label="give feedback"
                onClick={this.openOrderFeedback(item, index)}
              >
                <CommentIcon style={{ color: WELCOME_PAGE.primaryColor }} />
              </IconButton>
            </ListItemSecondaryAction>
          )}
          {showReplyIcon && (
            <ListItemSecondaryAction>
              <IconButton
                aria-label="give feedback"
                onClick={this.openOrderFeedback(item, index)}
              >
                <ReplyIcon style={{ color: WELCOME_PAGE.primaryColor }} />
              </IconButton>
            </ListItemSecondaryAction>
          )}
        </ListItem>
      </React.Fragment>
    ));
    if (this.state.activeTab === "Notifications") {
      content = Object.keys(notifications).map(notif => (
        <ListItem
          button
          role={undefined}
          divider
          onClick={this.props.handleNotificationClick({
            [notif]: notifications[notif]
          })}
        >
          <ListItemText
            primary={(notifications[notif] || {}).title || ""}
            secondary={(notifications[notif] || {}).message || ""}
            classes={{
              primary: classes.primaryText,
              secondary: classes.secondaryText
            }}
          />
        </ListItem>
      ));
    }

    return (
      <Dialog
        open={open}
        scroll="paper"
        aria-labelledby="feedback list dialog"
        classes={{ paper: root }}
      >
        {/* <DialogTitle
          disableTypography
          id="feedback-list-dialog"
          classes={{ root: Title }}
        >
          {title}
        </DialogTitle> */}
        <DialogContent
          classes={{
            root: classes.dialogContentRoot
          }}
        >
          <Grid container justify="center">
            {TYPES.map(type => {
              let isActiveTab = this.state.activeTab === type;

              return (
                <Grid
                  className={
                    isActiveTab
                      ? classes.activeContainer
                      : classes.inactiveContainer
                  }
                  item
                  onClick={this.switchTabs(type)}
                  md={6}
                  sm={6}
                  xs={6}
                >
                  <Typography
                    style={{
                      color: isActiveTab && "white",
                      fontWeight: "bold",
                      textTransform: "uppercase",
                      fontSize: this.props.isMobile && "12px"
                    }}
                    variant="subheading"
                  >
                    {type}
                  </Typography>
                </Grid>
              );
            })}
          </Grid>
          {content}
        </DialogContent>
        {(skip || showIcon) && (
          <DialogActions>
            <Button
              variant="contained"
              className={SkipBtn}
              onClick={() => handleClose({ state: false, clickedSkip: true })}
            >
              {showIcon ? "Skip" : "Close"}
            </Button>
          </DialogActions>
        )}
      </Dialog>
    );
  }
}

export default withStyles(styles)(FeedbackList);



// WEBPACK FOOTER //
// ./src/components/Dashboard/FeedbackList.js